import { fk } from "redux-orm";
import { attr } from 'redux-orm'
import Base from './Base'

class Contact extends Base {
  static get fields() {
    return {
      id: attr(),
      createdAt: attr(),
      firstName: attr(),
      lastName: attr(),
      gender: attr(),
      email: attr(),
      birthday: attr(),
      securityNumber: attr(),
      phone: attr(),
      isArchived: attr(),
      addressId :fk({to: 'address', as: 'address', relatedName: 'contacts'}),
    }
  }
}

Contact.modelName = 'contact'

export default Contact;
